import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import '../styles/preview.css';
import axios from 'axios';
import config from '../config';
import { useCart } from "./CartContext"
import GroupedModal from "./GroupedModal.jsx";

import 'react-image-crop/dist/ReactCrop.css'

import { pdfjs } from "react-pdf";

const host = config.backendUrl;

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function Preview({title}) {
    const { productId, itemId } = useParams();
    const [product, setProduct] = useState(null);
    const [pdf, setPdf] = useState(null);
    const [pdfSpecs, setPdfSpecs] = useState(null);
    const [choices, setChoices] = useState({});
    const [error, setError] = useState(null);
    const [openModal, setOpenModal] = useState(null);

    const [groupedModals, setGroupedModals] = useState({});

    const { cart, addItem, updateItem } = useCart();

    const effectRan = useRef(false);

    useEffect(() => {
        document.title = title;
        if (effectRan.current === false) {
            fetchProductData();
            effectRan.current = true;
        }
    }, [productId]);

    const openDB = () => {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open("GFUserDB", 1);
            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains("products")) {
                    db.createObjectStore("products", { keyPath: "key" });
                }
                if (!db.objectStoreNames.contains("items")) {
                    db.createObjectStore("items", { keyPath: "key" });
                }
            };
            request.onsuccess = (event) => {
                resolve(event.target.result);
            };
            request.onerror = (event) => {
                reject("Failed to open IndexedDB");
            };
        });
    };
    
    const saveToIndexedDB = async (key, value) => {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction("items", "readwrite");
            const store = transaction.objectStore("items");
            const request = store.put({ key, value });
            request.onsuccess = () => resolve(true);
            request.onerror = () => reject("Failed to save data to IndexedDB");
        });
    };
    
    const getFromIndexedDB = async (key) => {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction("items", "readonly");
            const store = transaction.objectStore("items");
            const request = store.get(key);
            request.onsuccess = () => resolve(request.result?.value || null);
            request.onerror = () => reject("Failed to retrieve data from IndexedDB");
        });
    };

    const fetchProductData = async () => {
        fetch(`${host}/api/products/${productId}`,
            {
                method: "GET",
                headers: {
                    "X-API-Key": process.env.REACT_APP_GANDF_KEY
                }
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setProduct(data);
                const modals = data.personalizations.filter((p) => p.type === 'modal');

                if (modals.length > 0) {
                    // Group modals by page number
                    const grouped = modals.reduce((acc, modal) => {
                        const page = modal.page;
                        if (!acc[page]) {
                            acc[page] = [];
                        }
                        acc[page].push(modal);
                        return acc;
                    }, {});
                    setGroupedModals(grouped);
                }
            })
            .catch((error) => {
                console.error('Error fetching product:', error);
                setError('Failed to fetch product details');
            });

        
        let db_pdf = null;

        db_pdf = await getFromIndexedDB(itemId);

        console.log(db_pdf)

        if (!db_pdf) {
            console.log("Fetching from cart")
            db_pdf = cart.find((item) => item.item_id === itemId);

            if (!db_pdf) {
                setError("Item not found in cart");
                return;
            }

            await saveToIndexedDB(itemId, db_pdf.choices);

            if (db_pdf.img_urls) {

                setPdf(db_pdf.img_urls);
                setPdfSpecs({
                    ...db_pdf,
                    img_urls: undefined
                });

                const choices = cart.find((item) => item.item_id === itemId).choices;
                setChoices(choices);

            }

        } else {
            console.log(db_pdf)
            setPdf(db_pdf.pdf.img_urls);
            setPdfSpecs({
                ...db_pdf.pdf,
                img_urls: undefined
            });

            setChoices(db_pdf);
        }

    };   

    const handleOpenModal = (modal) => {
        setOpenModal(modal);
    };

    const handleCloseModal = () => {
        setOpenModal(null);
    };

    const handleSaveGroupedModal = async (inputs) => {
        try {
            const existingChoices =  await getFromIndexedDB(itemId);
            const updatedChoices = {
                ...existingChoices,
                ...inputs,
                folder_id: choices.folder_id,
                page_num: openModal[0]?.page
            };

            // if there are files to upload, send them to the server
            const formData = new FormData();
            let hasFiles = false;

            for (const key in updatedChoices) {
                if (updatedChoices[key] instanceof File) {
                    formData.append(key, updatedChoices[key]);
                    hasFiles = true;
                }
            }

            let saveUploads;
            if (hasFiles) {
                formData.append("folder_id", updatedChoices.folder_id);

                saveUploads = await axios({
                    method: "post",
                    url: `${host}/api/products/${productId}/save-user-uploads`,
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "X-API-Key": process.env.REACT_APP_GANDF_KEY
                    }
                });

                // set the page to the user upload in updatedChoices
                for (const key in updatedChoices) {
                    if (updatedChoices[key] instanceof File) {
                        updatedChoices[key] = saveUploads.data.paths[key];
                    }
                }

                await saveToIndexedDB(itemId, updatedChoices);
            }

            if (!hasFiles || (saveUploads && saveUploads.status === 200)) {
                const response = await axios({
                    method: "post",
                    url: `${host}/api/products/${productId}/preview-page`,
                    data: updatedChoices,
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-Key": process.env.REACT_APP_GANDF_KEY
                    }
                });

                setPdf({
                    ...pdf,
                    [openModal[0].page + 1]: response.data.img_url
                });

                
                await saveToIndexedDB(itemId, {
                    ...updatedChoices,
                    pdf: {
                        ...pdfSpecs,
                        img_urls: {
                            ...pdf,
                            [openModal[0].page + 1]: response.data.img_url
                        }
                    }
                });

                setChoices(updatedChoices);
                handleCloseModal();
            } else {
                throw new Error("Failed to save uploads");
            }
    
        } catch (error) {
            console.error("Error saving modal data:", error);
            setError(error.response?.data?.message || "Failed to save modal data");
        }
    };

    const getValidModalsForPage = (pageModals) => {
        if (!pageModals) return [];

        return pageModals.filter(modal => 
            modal.condition === undefined || 
            modal.condition.values.includes(choices[modal.condition.key])
        );
    };

    const saveChanges = async () => {
        const item = cart.find((item) => item.item_id === itemId);

        updateItem(itemId, {
            choices: choices,
            image: pdf[0],
            pdf: {
                ...pdfSpecs,
                img_urls: pdf
            }
        },
        {
            recipient: choices.recipient,
            bookType: choices.bookType
        })

        window.location.href = window.location.origin + "/cart";
    }

    const backToCart = () => {
        const hasUnsavedChanges = JSON.stringify(choices) !== JSON.stringify(cart.find((item) => item.item_id === itemId)?.choices);
        if (hasUnsavedChanges) {
            if (window.confirm("Are you sure you want to go back to the cart? All unsaved changes will be lost.")) {
                window.location.href = window.location.origin + "/cart";
            }
        } else {
            window.location.href = window.location.origin + "/cart";
        }
    };

    if (error) {
            return (
                <div className="error-container">
                    <h2 className="error-title">Something didn't go as planned while creating your preview.</h2>
                    <p className="error-message">If this continues, please send us a note: <a href="mailto:hello@grieversandfriends.com">hello@grieversandfriends.com</a>.</p>
                    <p className="error-message">Thank you for your patience.</p>
                    <Link to={`/books/${productId}/personalize`} className="error-link">Back to Personalization</Link>
                </div>
            )
    }

    return (
        <div className="preview">
            
            {pdf && product && (
                <>
                    <div className="cart-preview-footer">
                        <div className="cart-preview-footer-buttons">
                            <button onClick={backToCart} className="back-link">Back to Cart</button>
                            <button onClick={saveChanges} className="purchase-link">Save Changes</button>
                        </div>
                    </div>

                    <div className="flipbook-container">
                        <div className="cover-container">
                            <img src={pdf[0] || ''} alt="page 1" width={1000} height={500} className="cover-image" />
                            <div className="cover-spine"></div>
                        </div>
                        {Array.from(new Array(Math.floor(product.numPages / 2) + (product.numPages % 2)), (el, index) => (
                            <div key={index} className="full-page">
                                <div className="page-pair">
                                <div className="page-container">
                                    <div className="page-content left">
                                        <img
                                            key={`page_${index * 2 + 2}`}
                                            src={pdf[index * 2 + 1] || ''}
                                            alt={`page ${index * 2 + 2}`}
                                            width={500}
                                            height={500}
                                            className={`pdf-page left ${(index * 2 + 2 === 2) ? 'blank' : ''}`}
                                        />
                                    </div>
                                    {(() => {
                                            const validModals = getValidModalsForPage(groupedModals[index * 2]);
                                            return validModals.length > 0 ? (
                                                <div className="modal-button-container">
                                                    <button 
                                                        className="modal-button"
                                                        onClick={() => handleOpenModal(validModals)}
                                                    >
                                                        Customize Page
                                                    </button>
                                                </div>
                                            ) : null;
                                        })()}
                                    </div>
                                    <div className="center-fold">
                                        <div className="fold-gradient" />
                                    </div>
                                    <div className="page-container">
                                        <div className="page-content right">
                                            <img
                                                key={`page_${index * 2 + 3}`}
                                                src={pdf[index * 2 + 2] || ''}
                                                alt={`page ${index * 2 + 3}`}
                                                width={500}
                                                height={500}
                                                className={`pdf-page right ${(index * 2 + 3 == product.numPages + 2) ? 'blank' : ''}`}
                                            />
                                        </div>
                                        {(() => {
                                            const validModals = getValidModalsForPage(groupedModals[index * 2 + 1]);
                                            return validModals.length > 0 ? (
                                                <div className="modal-button-container">
                                                    <button 
                                                        className="modal-button"
                                                        onClick={() => handleOpenModal(validModals)}
                                                    >
                                                        Customize Page
                                                    </button>
                                                </div>
                                            ) : null;
                                        })()}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </>
            )}

            {!pdf && (
                <div className="flipbook-container">
                    <div className="loader"></div>
                    <p className="loading-text">Retrieving your personalized picture book...</p>
                </div>
            )}

            {openModal && (
                <GroupedModal 
                    isOpen={true}
                    modals={Array.isArray(openModal) ? openModal : [openModal]}
                    choices={choices}
                    onModalClose={handleCloseModal}
                    onSave={handleSaveGroupedModal}
                />
            )}
        </div>
    );
}
